// This file can be replaced during build by using the `fileReplacements` array.
// `ng build --prod` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

export const environment = {
  production: false,

  firebaseConfig: {
    apiKey: 'AIzaSyD7zIAeB3DB3r1NFLSOpr-iabTvPMzMuk0',
    authDomain: 'asharplight-one.firebaseapp.com',
    databaseURL: 'https://asharplight-one.firebaseio.com',
    projectId: 'asharplight-one',
    storageBucket: 'asharplight-one.appspot.com',
    messagingSenderId: '243841293577'
  },

  agmAPIKey: '',

  stripePublicKey: 'pk_test_rr6QQrzfbOWUhYPzQBkudb8X00DHk5Qjn4'

};

/*
 * For easier debugging in development mode, you can import the following file
 * to ignore zone related error stack frames such as `zone.run`, `zoneDelegate.invokeTask`.
 *
 * This import should be commented out in production mode because it will have a negative impact
 * on performance if an error is thrown.
 */
// import 'zone.js/dist/zone-error';  // Included with Angular CLI.
